export default "__VITE_ASSET__c6299b3a__"